import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circular-spinner',
  templateUrl: './circular-spinner.component.html',
  styleUrls: ['./circular-spinner.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class CircularSpinnerComponent {
  @Input() public background: boolean = false;
  @Input() public whiteBackground: boolean = false;
}
